import { COSMETICS, type CosmeticDef } from '@/models/cosmetics';

const SHOP_SLOT_COUNT = 4;

function hashDate(dateStr: string): number {
  let hash = 0;
  for (let i = 0; i < dateStr.length; i++) {
    hash = ((hash << 5) - hash) + dateStr.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export class DailyShopManager {
  getShopItems(dateStr?: string): CosmeticDef[] {
    const date = dateStr ?? new Date().toISOString().split('T')[0]!;
    const shopCatalog = COSMETICS.filter(c => c.source === 'shop');
    if (shopCatalog.length === 0) return [];

    const seed = hashDate(date);
    const items: CosmeticDef[] = [];
    const used = new Set<number>();

    for (let slot = 0; slot < SHOP_SLOT_COUNT && slot < shopCatalog.length; slot++) {
      let idx = (seed + slot * 7 + slot * slot * 3) % shopCatalog.length;
      while (used.has(idx)) {
        idx = (idx + 1) % shopCatalog.length;
      }
      used.add(idx);
      items.push(shopCatalog[idx]!);
    }
    return items;
  }

  getGemPrice(cosmetic: CosmeticDef): number {
    switch (cosmetic.rarity) {
      case 'common': return 20;
      case 'rare': return 50;
      case 'epic': return 100;
      case 'legendary': return 200;
    }
  }
}
